<div class="mdp-month">
  <h3>{{monthLabel}}</h3>
  <div class="mdp-day-grid">
    <button class="btn btn-sem d-inline-flex justify-content-center align-items-center" *ngFor="let day of days" (click)="onDayClick(day)" [class.btn-secondary]="isSelected(day)" [class.btn-outline-secondary]="!isSelected(day)">{{day}}</button>
  </div>
</div>
